import { post, get, baseURL } from "@/utils/request";

// i18n API
export const getI18nList = (data: any) => get(`/I118/get?lang=${data}`);

export const getPWADomainInfo = () => get(`/pwaReward/domain/info`);

export const PWARewardAPI = () => post(`/pwaReward/claim`);

export const getAndroidDownloadURL = (data: any) => post(`/Parameter/getParam`, data);